import { useSelector } from "react-redux";
import { selectIosFullscreenOverlayActive } from "../State/selectors";
import { FEATURES_CONFIG } from "../featuresConfig";

/**
 * useIosOverlayGuard — Shared hook for HTML overlays that must hide
 * when the iOS fullscreen spine overlay is active.
 *
 * Checks both the feature flag (FEATURES_CONFIG.IOS_FULLSCREEN_OVERLAY.ENABLED)
 * and the Redux state (iosFullscreenOverlayActive).
 *
 * @returns {{ guardStyle: object, isHidden: boolean }}
 *   - guardStyle: spread onto root <div> style — opacity/visibility/pointerEvents when hidden
 *   - isHidden: boolean for logic that needs to pause (e.g., scroll position reset)
 */
export const useIosOverlayGuard = () => {
  const iosActive = useSelector(selectIosFullscreenOverlayActive);

  // Only guard if iOS overlay feature is enabled AND currently showing
  const isHidden =
    FEATURES_CONFIG.IOS_FULLSCREEN_OVERLAY.ENABLED && iosActive;

  return {
    guardStyle: isHidden
      ? { opacity: 0, visibility: "hidden", pointerEvents: "none" }
      : {},
    isHidden,
  };
};
